export default "__VITE_ASSET__BUcVzVJK__"